module.exports = __webpack_public_path__ + "static/media/yellow.e318aad4.png";